import { render } from "./SystemSubjects.vue?vue&type=template&id=349dd17b&ts=true"
import script from "./SystemSubjects.vue?vue&type=script&lang=ts"
export * from "./SystemSubjects.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__